import { z } from 'zod';
import { EbpCaseSupportAuthorizationSchema } from './EbpCaseSupportAuthorizationSchema';
import { dateValidation, coerceNumber } from '../../../validation';

// Miro board: https://miro.com/app/board/uXjVMyBaM2M=
export const EbpCaseSupportSchema = z.object({
  // end of Perci support date, for Level 1 and Level 2
  endDate: dateValidation().optional(),

  // max allowed session
  // for Level 2: all completed appointments by professionals, not the assigned nurse (expert)
  // and Level 3: all completed appointments by professionals or nurses
  maxAppointments: coerceNumber(z.number()).optional(),

  // To nurses in Slack:
  // 2 weeks before the end date or
  // ending professional sessions for Level 2 support
  endNotificationOne: z.boolean().optional(),

  // To nurses in Slack:
  // 1 week has passed since the last Nurse (expert) appointment,
  // and not future bookings exist
  noFutureBookingNotification: z.boolean().optional(),

  // requests to extend
  authorization: EbpCaseSupportAuthorizationSchema.optional(),
});

export type EbpCaseSupport = z.infer<typeof EbpCaseSupportSchema>;
